// Path: ./src/app/pages/CreateNotificationPage/index.tsx
import { Grid, TextareaAutosize } from "@mui/material";
import { useState } from "react";

import { UpdateNotificationDto } from "@swagger/typescript-fetch-goflyer";
import { useNavigate } from "react-router-dom";

import { messages } from "../../../locales/messages";
import { useTranslation } from "react-i18next";
import { AccountCardWrapper } from "../../components/AccountCardWrapper";
import {
  SetupPageContainer,
  TextInputField,
} from "../../../utils/commonStyledComponents/commonStyled";
import { useHandleSaveNotification } from "./handleNotificationStore";
import {
  CancelButton,
  ColorButton,
} from "../../../utils/commonStyledComponents/commonMuiStyled";
import {
  GridWrapper,
  ButtonWrapper,
  InputLabelText,
  Wrapper,
} from "../../components/AccountPageCreatePageCommon";

const CreateNotificationPage = () => {
  // 1. React Router hooks
  const navigate = useNavigate();
  // 2. Custom hooks - Localization and Data fetching
  const { t } = useTranslation();

  // 3. State for Dtos, models and data
  const [updateNotification, setUpdateNotification] =
    useState<UpdateNotificationDto>();

  const handleCancel = async () => {
    navigate(-1);
  };
  const handleSaveNotification = useHandleSaveNotification();
  return (
    <SetupPageContainer data-testid="create-notification-page">
      <AccountCardWrapper
        title={t(messages.Create()) + t(messages.Notifications())}
      >
        <GridWrapper>
          <Grid
            container
            spacing={2}
            style={{ marginTop: 10, maxWidth: 700, padding: 10, width: "100%" }}
          >
            <Grid
              item
              xs={12}
              md={12}
              style={{
                width: "100%",
              }}
            >
              <Wrapper>
                <InputLabelText>
                  {`Title`} ({t(messages.required())})
                </InputLabelText>
                <TextInputField
                  value={updateNotification?.title}
                  data-testid="create-notification-title-input"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUpdateNotification((prev) => {
                      return {
                        ...prev,
                        title: event.target.value,
                      };
                    });
                  }}
                />
              </Wrapper>
              <Wrapper>
                <InputLabelText>
                  {`Body`} ({t(messages.required())})
                </InputLabelText>
                <TextareaAutosize
                  style={{
                    width: "57%",
                    marginBottom: 10,
                  }}
                  minRows={4}
                  value={updateNotification?.body}
                  data-testid="create-notification-body-input"
                  onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setUpdateNotification((prev) => {
                      return {
                        ...prev,
                        body: event.target.value,
                      };
                    });
                  }}
                />
              </Wrapper>
              <Wrapper>
                <InputLabelText>
                  {`Url`} ({t(messages.required())})
                </InputLabelText>
                <TextInputField
                  value={updateNotification?.url}
                  data-testid="create-notification-url-input"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setUpdateNotification((prev) => {
                      return {
                        ...prev,
                        url: event.target.value,
                      };
                    });
                  }}
                />
              </Wrapper>
            </Grid>
            <Grid item xs={12}>
              <ButtonWrapper>
                <CancelButton
                  variant="contained"
                  onClick={handleCancel}
                  data-testid="create-store-cancel-button"
                >
                  {t(messages.Cancel())}
                </CancelButton>
                <ColorButton
                  variant="contained"
                  onClick={async () => {
                    await handleSaveNotification(updateNotification);
                  }}
                  data-testid="create-store-finish-button"
                >
                  {t(messages.Finish())}
                </ColorButton>
              </ButtonWrapper>
            </Grid>
          </Grid>
        </GridWrapper>
      </AccountCardWrapper>
    </SetupPageContainer>
  );
};

export default CreateNotificationPage;
